import { call } from 'redux-saga/effects'
import { APIS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'

export function* country<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.COUNTRY, action.payload, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch country data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}

export function* zones<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.ZONE, action.payload, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch zone data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}

export function* roles<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.ROLE, action.payload, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch roles data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}

export function* commonDropdowns<P, R>(action: {
    type: string
    payload: {
        payload: string
        zone_id?: string
    }
    onSuccess: (response: SuccessResponse<R>) => void
    onError: (response: ErrorResponse<R>) => void
}): any {
    try {
        const payload = action.payload.payload
        const data: any = action.payload
        let isAuth = true
        if (data?.remove_is_auth) {
            isAuth = false
        }
        delete data.payload
        const resp = yield call(CallApi.GET, APIS.COMMON.ALLDROPDOWN(payload), data, false, isAuth, isAuth)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch dropdown data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}

export function* businessfunction<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.BUSINESS_FUNCTION, action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch business function data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}

export function* getUseCases<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.USE_CASES, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch use cases data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}
export function* getKpiInterests<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.BUSINESS_FUNCTION, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch KPI interests data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}
export function* getKpiTypes<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.KPI_TYPES, action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch KPI types data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}

export function* getExperimentTypes<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.EXPERIMENTS_TYPES, action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch experiment types data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}

export function* getUserList<P, R>(action: {
    type: string
    payload: {
        sort_by: string
        page: number
        per_page: number
        zone_ids: string
        country_ids: string
        business_function_ids: string
    }
    onSuccess: (response: SuccessResponse<R>) => void
    onError: (response: ErrorResponse<R>) => void
}): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.USERS, action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch user list data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}
export function* getExptSharableUserList<P, R>(action: {
    type: string
    payload: {
        literal: string
        [name: string]: any
    }
    onSuccess: (response: SuccessResponse<R>) => void
    onError: (response: ErrorResponse<R>) => void
}): any {
    try {
        const literal: string = action?.payload?.literal
        const queryString: any = action.payload
        delete queryString.literal

        const resp = yield call(CallApi.GET, APIS.COMMON.EXPT_SHARABLE_USER(literal), queryString, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp as SuccessResponse<R>)
        } else {
            action?.onError(resp as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch sharable user list data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}

export function* getTopActiveUserList<P, R>(action: {
    type: string
    payload: {
        sort_by: string
        page: number
        per_page: number
        zoneids: string
        countryids: string
    }
    onSuccess: (response: SuccessResponse<R>) => void
    onError: (response: ErrorResponse<R>) => void
}): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.TOP_ACTIVE_USERS, action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        //  action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch top active user list data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}

export function* getGroupDownsExpStatus<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.EXP_STATUS, action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch experiment status data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}
export function* getAdvanceConfigOption<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.ADVANCE_CONFIG_OPTION, action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch advance config option data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}

export function* getProdcutInfo<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.PRODUCT_INFO, action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch product info data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}
export function* getCurrency<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_CURRENCY, { paginate: false, ...action.payload }, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch currency data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}

export function* getVolume<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_VOLUME, { paginate: false, ...action.payload }, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch volume data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}
export function* getExperimentAccess<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.COMMON.GET_EXPERIMENT_ACCESS(action.payload.literal), {}, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch experiment status data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}
export function* getAdvanceConfigurationOption<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.COMMON.GET_ADVANCE_CONFIG_OPTION, action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch advance config option data',
                status_code: e?.status || 500,
                success: false,
            },
        )
    }
}
